import React, { useState } from "react";
import { Loader2, MailCheck } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export function ForgotPasswordForm({ initialEmail = "", onBack }) {
  const [email, setEmail] = useState(initialEmail);
  const [sent, setSent] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError("");
    try { const { data } = await api.post("/auth/forgot-password", { email: email.trim() }); setSent(data.message); }
    catch (err) { setError(formatApiError(err.response?.data?.detail)); }
    setBusy(false);
  };
  return (
    <form onSubmit={submit} className="px-7 py-6 space-y-3" data-testid="forgot-form">
      {sent ? (
        <p className="flex gap-2 items-start text-sm font-semibold text-biga-green bg-biga-green/10 rounded-xl p-3" data-testid="forgot-sent"><MailCheck size={18} className="shrink-0" /> {sent} The link works once and expires in 1 hour.</p>
      ) : (
        <>
          <p className="text-sm text-biga-ink/70">Enter your email and we'll send you a link to set a new password.</p>
          <input data-testid="forgot-email" required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-3 rounded-xl border-2 border-biga-ink/15 focus:border-biga-orange outline-none font-medium" />
          {error && <p data-testid="forgot-error" className="text-sm text-red-600 font-semibold">{error}</p>}
          <button data-testid="forgot-submit" disabled={busy} className="w-full bg-biga-green text-biga-cream font-bold py-3.5 rounded-xl hover:bg-biga-ink transition-colors flex items-center justify-center gap-2">
            {busy && <Loader2 className="animate-spin" size={18} />} Send reset link
          </button>
        </>
      )}
      <p className="text-center text-sm font-medium pt-1"><button type="button" data-testid="forgot-back" onClick={onBack} className="text-biga-orange font-bold underline underline-offset-2">Back to sign in</button></p>
    </form>
  );
}
